import React, { useState } from "react";
import DetectorApp from "./DetectorApp";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import LoginModal from "../components/LoginModal";
import SignupModal from "../components/SignupModal";

export default function AdminDetector() {
  const navigate = useNavigate();
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);

  const handleLoginSuccess = () => {
    setShowLogin(false);
    setShowSignup(false);
  };

  return (
    <div style={styles.page}>

      <Navbar onLoginClick={() => setShowLogin(true)} />
      <div style={styles.container}>
        <div style={styles.contentWrapper}>
          <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}>
          </h2>
          <DetectorApp />
        </div>
      </div>

      {showLogin && (
        <LoginModal
          onClose={() => setShowLogin(false)}
          onLoginSuccess={handleLoginSuccess}
          openSignup={() => {
            setShowLogin(false);
            setShowSignup(true);
          }}
        />
      )}

      {showSignup && (
        <SignupModal
          onClose={() => setShowSignup(false)}
          openLogin={() => {
            setShowSignup(false);
            setShowLogin(true);
          }}
        />
      )}

      <footer style={styles.footer}>
        Navriti Technologies © All rights reserved
      </footer>
    </div>
  );
}


const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f8fafc, #eef2ff)",
    fontFamily: "Poppins, sans-serif",
    paddingBottom: "0px",
    overflowX: "hidden",
    width: "100vw",
  },

  footer: {
    width: "100%",
    backgroundColor: "#636CCB",
    color: "white",
    textAlign: "center",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "600",
    fontSize: "1em",
    position: "fixed",
    bottom: 0,
    left: 0,
    zIndex: 2000,
  },

  contentWrapper: {
    maxWidth: "100%",
    margin: "0",
    width: "100%",
    padding: "0",
  },
};
